<template>
  <el-card shadow="never">
    <div class="goods-image-main">
      <div class="d-flex align-items-center">
        <span style="font-size: 14px; color: #606266;line-height: 35px;">
          {{ data.orderGoodsName || '--' }}
        </span>
      </div>
      <el-divider></el-divider>
      <GoodsImageList
        :data="data.listImage"
        :expandContent="data.isGroup === 'N'"
      />
      <div v-if="data.isGroup === 'Y'">
        <div v-for="(item, index) in data.listGoodsSpec || []" :key="index">
          <GoodsSpecImage
            :title="item.identifyGoodsName"
            :data="item.listImage"
          />
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import GoodsImageList from '../goods-image-list'
import GoodsSpecImage from './components/goods-spec-images'
export default {
  props: { orderGoodsCode: { type: String, default: '' } },
  components: { GoodsImageList, GoodsSpecImage },
  data() {
    return {
      data: {},
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.orderGoodsCode) return
      const res = await this.$api
        .pendingOrderGoodsSelectImagesApi({
          orderGoodsCode: this.orderGoodsCode,
        })
        .catch(() => null)
      const { body, status } = res || {}
      if (status !== 200 || !body) return
      this.data = body
    },
  },
}
</script>

<style lang="scss" scoped>
.goods-image-main {
  height: calc(100vh - 10vh - 155px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.el-divider.el-divider--horizontal {
  margin: 5px 0;
}
::v-deep .el-card__body {
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
